import { render, staticRenderFns } from "./LdarDetail.vue?vue&type=template&id=23faa6a7&scoped=true"
import script from "./LdarDetail.vue?vue&type=script&lang=js"
export * from "./LdarDetail.vue?vue&type=script&lang=js"
import style0 from "./LdarDetail.vue?vue&type=style&index=0&id=23faa6a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23faa6a7",
  null
  
)

export default component.exports